import React, { useState, useEffect, useRef, useContext } from "react";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { AuthContext } from "../../../Header/auth - context";
import { Button } from 'primereact/button';
import { MultiSelect } from 'primereact/multiselect';
import { Tooltip } from 'primereact/tooltip';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { confirmDialog } from 'primereact/confirmdialog';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { useSessionHelper } from '../../../custom/sessionHelper';
import { openSessionModal } from '../../../store/sessionModalSlice';
import useVisinaTabele from "../../../custom/visinaTabele";

const PregledFaktura = (props) => {
  const { t } = useTranslation();
  const toast = useRef(null);
  const auth = useContext(AuthContext);
  const company = useSelector(state => state.company);
  const user = useSelector(state => state.user)
  const invoice = useSelector(state => state.invoice);
  const { sessionHelper } = useSessionHelper();
  const dispatch = useDispatch();
  /* Kada je SEF poslednji put pitan za statuse OVE firme — svejedno da li ga
     je pitao noćni posao (svakih 30 min) ili operater dugmetom. Izvor je isti
     zapis u sef.RequestLog, pa se broj ne razilazi. */
  const [sefOsvezeno, setSefOsvezeno] = useState(null);
  const [sefOsvezava, setSefOsvezava] = useState(false);
  /* Bump posle osvežavanja — tera efekat iznad da ponovo povuče tabelu. */
  const [ponovoUcitaj, setPonovoUcitaj] = useState(0);
  const [tableData, setTableData] = useState(null);
  const [allColumns, setAllColumns] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [originalColumnOrder, setOriginalColumnOrder] = useState([]);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [first, setFirst] = useState(0);
  const getId = (row) => row?.ID ?? row?.id ?? row?.Izaberi ?? null; // ➜ stabilan ključ
  const [selectedRowId , setSelectedRowId] = useState(null);
  const isSelected = (row) => String(getId(row)) === String(selectedRowId);
  const [izabran, setIzabran] = useState(false)
  /* Spisak se zavrsava na dnu ekrana; visina se MERI, ne pogadja. */
  const [omotTabele, visinaTabele, redovaTabele] = useVisinaTabele([tableData, izabran]);

  // Path normalization and document location helper
  const getDocumentLocation = (path) => {
    if (!path) return null;
    
    // Normalize Windows path to URL format
    const normalizedPath = path.replace(/\\/g, '/');
    
    // Remove full C:/Dokumenta/ from path
    const relativePath = normalizedPath.replace(/^C:\/Dokumenta\//, '');
    const encodedPath = encodeURI(relativePath); // Encode spaces, etc.
    return `${process.env.REACT_APP_BACKEND_URL}/files/${encodedPath}`;
  };

  const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };

  const getConfigColumns = async () => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + auth.token,
    },
    body: JSON.stringify({
      id_config: 309
    }),
  };

    const data = await fetch(process.env.REACT_APP_BACKEND_URL + "/config/", requestOptions)
      .then(handleErrors); 

    if (data.message) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: data.message,
        life: 3000,
      });
      return { empty: true, data: [] };
    }

     if(data.length > 0) {
                    return { empty: false, data: data };
                } else {
                    return { empty: true, data: [] };
                }


};

  useEffect(() => {

    if(invoice) {
        dispatch({
          type: "INVOICE",
          value: null
         });
    }
    
    let requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + auth.token,
      },
      body: JSON.stringify({
        tip: 303,
        pregled: 'FAKTURA'
      }),
    };
    
    fetch(process.env.REACT_APP_BACKEND_URL + "/invoice/GetALLInvoicesData", requestOptions)
      .then(handleErrors)
      .then(async (data) => {

        setTableData(data);
        
        // Extract all available columns from the first data row
            if (data && data.length > 0) {
        const columns = Object.keys(data[0])
            .filter(key => !['ID'].includes(key))
            .map(key => ({
            label: key,
            value: key
            }));
  

          setAllColumns(columns);
          const originalOrder = Object.keys(data[0]);
          setOriginalColumnOrder(originalOrder);
          
          const columnsDB = await getConfigColumns();

              if (!columnsDB.empty && columnsDB.data.length > 0) {
                const arr = JSON.parse(columnsDB.data[0].parametri);
                setSelectedColumns(arr);
              } else {
                setSelectedColumns(columns.slice(0, 5).map(col => col.value));
              }
        }
      })
      .catch((error) => {
        error.json().then((errorMessage) => {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: errorMessage.message,
            life: 3000,
          });
          console.log(errorMessage);
        });
      });
  }, [auth.token, company.companyId, ponovoUcitaj]);


  const handleEditInvoice = (id) => {
    
        confirmDialog({
          message: "Jel ste sigurni da želite nastaviti sa editovanjem fakture?",
          acceptLabel: "Da",
          rejectLabel: "Ne",
          icon: "pi pi-info-circle",
          acceptClassName: "p-button-danger",
          accept: () => acceptEdit(id),
          reject: rejectEdit,
        });
  }

  const acceptEdit = (id) => {
    props.setIdInvoice(id.Izaberi)
    if(id['Podtip fakture'] == 'Dinarska faktura')
        props.setChangeView(1)
    else
        props.setChangeView(2)
  }

  const rejectEdit = () => {
        setIzabran(false);
        dispatch({ type: "INVOICE", value: null });
        setSelectedRowId(null)
  }

  
  const chooseInvoice = async (rowData) => {    
    const id = getId(rowData);

       let resultSession = await sessionHelper(user.userId,'IZFAKTURA', id)
  
      if(resultSession.zauzeto) {
                  dispatch(openSessionModal({
                    type: "SESSION_LOCK",
                    message: resultSession.message
                  }));
                  return
      }

    setSelectedRowId((prev) => {
      const next = String(prev) === String(id) ? null : String(id);

    if (next) {
      // selekcija
      const invoiceID = tableData?.find(t => String(t.Izaberi) === String(rowData.Izaberi));
      if (invoiceID) {
    
        setIzabran(true);
      }
      dispatch({ type: "INVOICE", value: rowData.Izaberi });
     
      handleEditInvoice(invoiceID)
    } else {
      setIzabran(false);
      dispatch({ type: "INVOICE", value: null });
    }

    return next;
  });
  }


   const previewBodyTemplate = (rowData, field) => {
    const filePathsString = rowData[field];
    if (!filePathsString) return '-';
  
       if(field == 'Izaberi') {
    
          const selected = isSelected(rowData);
           return (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                      <Button
                        label='Izaberi'
                        icon="pi pi-eye"
                        className="p-button-text p-button-sm"
                        onClick={(e) => chooseInvoice(rowData)}
                        tooltip="Izaberi fakturu za dalji rad"
                        tooltipOptions={{ position: 'top' }}
                      />
                    
                </div>
              );
       } else {

    const filePaths = filePathsString.split('|').filter(p => p.trim() !== '');
  
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        {filePaths.map((path, idx) => {
          const documentUrl = getDocumentLocation(path);
          if (!documentUrl) return null;
  
          // Izdvoji ime fajla bez ekstenzije
          const fileNameWithExt = path.split('/').pop(); // npr. TOI-Psihologija-2016-testkljuc_20250726222909703.pdf
          const fileName = fileNameWithExt.replace(/\.(pdf|jpg|png)$/i, '');
  
          return (
            <Button
              key={idx}
              label={fileName}
              icon="pi pi-eye"
              className="p-button-text p-button-sm"
              onClick={() => window.open(documentUrl, '_blank')}
              tooltip="Pregledaj dokument"
              tooltipOptions={{ position: 'top' }}
            />
          );
        })}
      </div>
    ); }
  };

  const isFileColumn = (field) => {
    return field.startsWith('Prilozi') || 
           field.includes('Izaberi') || 
           field.includes('fajl') || 
           field.includes('upload') ||
           field.endsWith('LK') || // Lična karta
           field.endsWith('VD') || // Vozačka dozvola
           field.endsWith('PASS') || // Pasoš
           field.endsWith('VIZA') || // Viza
           field.includes('Dokument'); // Generic document
  };

const exportExcel = async () => {
    if (!selectedColumns || selectedColumns.length === 0) return;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Izlazna fakture');

    // Use selectedColumns instead of all table keys
    const headers = selectedColumns;

    // Add header row
    const headerRow = worksheet.addRow(headers);
    headerRow.font = { bold: true };
    headerRow.eachCell((cell) => {
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFEFEFEF' }
        };
        cell.border = {
            top: { style: 'medium' },
            left: { style: 'medium' },
            bottom: { style: 'medium' },
            right: { style: 'medium' }
        };
    });

    // Add filtered data rows
    tableData.forEach((rowData) => {
        const row = worksheet.addRow(headers.map(h => rowData[h] ?? ""));
        row.eachCell((cell) => {
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };
        });
    });

    // Auto-size columns
    worksheet.columns.forEach((column, i) => {
        const lengths = [
            headers[i].length,
            ...tableData.map(row => (row[headers[i]] ?? "").toString().length)
        ];
        column.width = Math.max(...lengths) + 2;
    });

    // Serbian-formatted datetime
    const date = new Date();
    const options = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'Europe/Belgrade'
    };
    const serbianDateTime = date.toLocaleString('sr-RS', options)
        .replace(/\s/g, ' ')
        .replace(/,/g, '');

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, `Izlazne fakture - ${company.companyName} - ${serbianDateTime}.xlsx`);
};
  const zaglavljaSef = () => ({
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + auth.token,
  });

  const ucitajSefOsvezeno = () => {
    fetch(process.env.REACT_APP_BACKEND_URL + '/sef/Osvezeno', { method: 'POST', headers: zaglavljaSef(), body: '{}' })
      .then(r => r.ok ? r.json() : null)
      .then(d => setSefOsvezeno(d?.kada ?? null))
      .catch(() => { /* vreme osvežavanja je sporedan podatak — ne ruši pregled */ });
  };

  useEffect(() => { ucitajSefOsvezeno(); /* eslint-disable-next-line */ }, []);

  const osveziSaSefa = async () => {
    setSefOsvezava(true);
    try {
      const r = await fetch(process.env.REACT_APP_BACKEND_URL + '/sef/OsveziStatuse', { method: 'POST', headers: zaglavljaSef(), body: '{}' });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d?.message || t('common.greska'));

      setSefOsvezeno(d.kada ?? null);
      toast.current?.show({
        severity: d.preostalo > 0 ? 'warn' : 'success',
        summary: t('fakture.sefOsvezavanje'),
        detail: d.preostalo > 0
          ? t('fakture.sefOsvezenoDeo', { broj: d.provereno, preostalo: d.preostalo })
          : t('fakture.sefOsvezenoSve', { broj: d.provereno }),
        life: 4000,
      });

      /* statusi su se mogli promeniti — tabela mora da ih pokaže */
      if (d.provereno > 0) setPonovoUcitaj((n) => n + 1);
    } catch (e) {
      toast.current?.show({ severity: 'error', summary: t('common.greska'), detail: e.message, life: 5000 });
    } finally {
      setSefOsvezava(false);
    }
  };

     const header = (
        <div className="export-buttons fakture-stavke-header">
            <div className="fakture-stavke-radnje">
                <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} data-pr-tooltip="XLS" />
                <Button type="button" icon="pi pi-sync" severity="info" rounded
                    onClick={osveziSaSefa} loading={sefOsvezava}
                    data-pr-tooltip={t('fakture.sefOsveziTooltip')} />
                {/* Vreme važi za OVU firmu, bez obzira ko je osvežio —
                    noćni posao ili operater ovim dugmetom. */}
                <span className="sef-osvezeno">
                    {t('fakture.sefOsvezeno')}: <strong>{sefOsvezeno || t('fakture.sefNikada')}</strong>
                </span>
            </div>
            <input type="search" placeholder={t('nova.phPretraga')}
                className="p-inputtext p-component"
                onInput={(e) => setGlobalFilter(e.target.value)} />
        </div>
    );

  const handleSaveConfig = () => {
         confirmDialog({
                    message: "Jel ste sigurni da želite sačuvati konfiguraciju?",
                    acceptLabel: "Da",
                    rejectLabel: "Ne",
                    icon: "pi pi-info-circle",
                    acceptClassName: "p-button-danger",
                    accept: acceptInsertConfig,
                    reject: rejectInsertConfig,
                    });
  }

  const acceptInsertConfig  = () => {
    if(selectedColumns.length > 0) {
       let requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + auth.token,
      },
      body: JSON.stringify({
        id_config: 309,
        parametri: selectedColumns
      }),
    };
    
    fetch(process.env.REACT_APP_BACKEND_URL + "/config/changeConfig", requestOptions)
      .then(handleErrors)
      .then((data) => {


          if(data.message && data.message == 'Nema izmena u podacima konfiguracije pregleda.'){
                toast.current.show({
                    severity: "warn",
                    summary: "Upozorenje!",
                    detail: data.message,
                    life: 3000,
                    });
                return
                }  
  
            toast.current.show({
                severity: "success",
                summary: "Uspešna izmena konfiguracije pregleda za izlazne fakture!",
                life: 3000,
            });

      })
      .catch((error) => {
        error.json().then((errorMessage) => {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: errorMessage.message,
            life: 3000,
          });
          console.log(errorMessage);
        });
      });
    } else {
        toast.current.show({
                    severity: "warn",
                    summary: "Upozorenje!",
                    detail: "Morate imati barem 1 izabranu stavku!",
                    life: 3000,
                    });
    }
     
  }
  const rejectInsertConfig = () => {
    console.log('Config insert rejected!')
  }

const parseDateOnly = (value) => {
  if (!value || typeof value !== "string") return null;

  const parts = value.split(".");
  if (parts.length < 3) return null;

  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10);
  const year = parseInt(parts[2], 10);

  if (!day || !month || !year) return null;

  const d = new Date(year, month - 1, day);
  d.setHours(0, 0, 0, 0);

  return isNaN(d.getTime()) ? null : d;
};

const isOverdue = (row) => {
  const rok = parseDateOnly(row?.["Rok plaćanja datum"]);
  if (!rok) return false;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return rok < today;
};

const isPaid = (row) => row?.["Finansijski status"] === "Naplaćena";

  return (
    <div className="zaposleni_table_container">
      <Toast ref={toast} />
      <ConfirmDialog />
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "1em" }}>
        <div style={{ width: "20%" }}>
          {allColumns.length > 0 && (
            <div style={{display:'flex', alignItems:'center', justifyContent:'center'}}>  <MultiSelect
              value={selectedColumns}
              options={allColumns}
              onChange={(e) => {
            const sorted = originalColumnOrder.filter((key) => e.value.includes(key));
            setSelectedColumns(sorted);
          }}
              optionLabel="label"
              display="chip"
              placeholder={t('nova.odaberiteKolone')}
              style={{ width: '100%' }}
              showSelectAll={true}
              filter
              filterPlaceholder="Pretraži kolone"
              maxSelectedLabels={3}
              selectedItemsLabel="{0} kolona odabrano"
            />
            <button onClick={handleSaveConfig} style={{marginLeft:'1%'}} className="configSaveButton"><i className="pi pi-save"></i></button></div>
          )}
          
        </div>
        {(izabran) && <p class="infoPoruka" style={{margin: '0', display: 'flex', alignItems: 'center'}}>Izlazna faktura je selektovana. Moguće ažuriranje njegovih podataka.</p>}
      </div>
     
      <Tooltip target=".export-buttons>button" position="bottom" />
      <div ref={omotTabele}>
      <DataTable
        value={tableData}
        paginator
        rows={redovaTabele}
        first={first}
        globalFilter={globalFilter}
        onPage={(e) => setFirst(e.first)}
        scrollable
        header={header}
        className="stavke-tabela"
        scrollHeight={visinaTabele}
        emptyMessage={t('common.noDataTable')}
        loading={tableData === null}
        resizableColumns
        columnResizeMode="expand"
        rowClassName={(rowData) => {
          const classes = [];

          if (isSelected(rowData)) {
            classes.push("selected-row");
          }

          if (isPaid(rowData)) {
            classes.push("row-green");
          } else if (isOverdue(rowData)) {
            classes.push("row-red");
          }

          return classes.join(" ");
        }}
      >
        {selectedColumns.map((colKey) => {
        const colMeta = allColumns.find(col => col.value === colKey);
        return (
          <Column
            key={colKey}
            field={colKey}
            header={colMeta?.label || colKey}
            sortable
            body={(rowData) => {
              if (isFileColumn(colKey)) {
                return previewBodyTemplate(rowData, colKey);
              }
              if (colKey === 'Status') {
                const isStorno = rowData['Status'] === 'Stornirana';
                return (
                  <span style={{
                    fontWeight: 600, fontSize: '0.82rem',
                    color: isStorno ? '#888' : '#2e7d32',
                    textDecoration: isStorno ? 'line-through' : 'none'
                  }}>
                    {isStorno ? 'Stornirana' : 'Aktivna'}
                  </span>
                );
              }
              const text = String(rowData[colKey] ?? '') || '-';
              if (text.length > 30) {
                return <span title={text}>{text.slice(0, 30) + '...'}</span>;
              }
              return text;
            }}
            style={{ minWidth: '150px'}}
          />
        );
      })}
      </DataTable>
      </div>
    </div>
  );
};

export default PregledFaktura;